import { getIconClassName } from '@uifabric/styling/lib/index';
import { observer } from 'mobx-react-lite';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import { AttachmentViewState } from 'owa-attachment-select-actions';
import { AttachmentThumbnailView } from 'owa-attachment-view';
import { ControlIcons } from 'owa-control-icons';
import { isThumbnailableDocument } from 'owa-file';
import { FileIcon, getIconForFile } from 'owa-file-icon';
import * as React from 'react';

export interface AttachmentImageCompactProps {
    attachmentViewState: AttachmentViewState;
}

const styles = require('./AttachmentCompactView.scss');
const classNames = require('classnames/bind').bind(styles);

// This component is responsible for showing the attachment image view.
const AttachmentImageCompactView = observer(function AttachmentImageCompactView(
    props: AttachmentImageCompactProps
) {
    const attachmentName: string = getAttachment(props.attachmentViewState.attachmentId).model.Name;
    let fileIconClass: string = null;
    const fileIcon: FileIcon = getIconForFile(attachmentName);
    let placeholderCssClass: string = getIconClassName(ControlIcons.Photo2);
    const smallFileIcon: string = fileIcon.small;

    if (isThumbnailableDocument(attachmentName)) {
        fileIconClass = smallFileIcon;
        placeholderCssClass = smallFileIcon;
    }

    const attachmentPlaceholderClassNames = classNames(styles.placeholder, placeholderCssClass);

    const width = 64;
    const height = 48;

    return (
        <span>
            <div className={styles.imageContainerDiv}>
                <AttachmentThumbnailView
                    attachmentViewState={props.attachmentViewState}
                    placeHolderCSSClass={attachmentPlaceholderClassNames}
                    fileIconCssClass={fileIconClass}
                    imageLoadErrorCSSClass={smallFileIcon}
                    thumbnailWidth={width}
                    thumbnailHeight={height}
                />
            </div>
        </span>
    );
});
export default AttachmentImageCompactView;
